import { render, staticRenderFns } from "./precos-comparativo.vue?vue&type=template&id=5938e336&scoped=true&"
import script from "./precos-comparativo.vue?vue&type=script&lang=js&"
export * from "./precos-comparativo.vue?vue&type=script&lang=js&"
import style0 from "./precos-comparativo.vue?vue&type=style&index=0&id=5938e336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5938e336",
  null
  
)

export default component.exports